import script from "./HealthGoals.vue?vue&type=script&lang=ts&setup=true"
export * from "./HealthGoals.vue?vue&type=script&lang=ts&setup=true"

import "./HealthGoals.vue?vue&type=style&index=0&id=f633d4f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f633d4f6"]])

export default __exports__